// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cmwE","left":"styles_left__26Z8f"};